























import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class AddEntity extends Vue {
  @Prop({ default: '' }) buttonText;
  @Prop({ default: () => {} }) onClick;
}
